// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_NOTESASSOCIATES = "GET_NOTESASSOCIATES";
export const CREATE_NOTESASSOCIATES = "CREATE_NOTESASSOCIATES";
export const UPDATE_NOTESASSOCIATES = "UPDATE_NOTESASSOCIATES";
export const DELETE_NOTESASSOCIATES = "DELETE_NOTESASSOCIATES";
